import React from "react";
import { Constants } from "../../../../CommonMethhods/Constants";

function PayoutDetailsTable() {
  return (
    <thead>
      <tr>
        <th scope="col">{Constants.Date_and_Time}</th>
        <th scope="col" className="text-center">
          {Constants.Amount}
        </th>
        <th scope="col" className="text-center">
          {Constants.Status}
        </th>
        <th scope="col" className="text-center">
          {Constants.BANK_NAME}
        </th>
        <th scope="col" className="text-center">
          {Constants.Bank_Account}
        </th>
        <th scope="col" className="text-center">
          {Constants.Reference_No}
        </th>
      </tr>
    </thead>
  );
}
export default PayoutDetailsTable;
